import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { colors } from "../../utils/Colors";
import Paths from "../../utils/Paths";

const c = colors.color;

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div
        style={{
          background: `linear-gradient(160deg, #fff8f8 0%, #fff 50%, ${c.secondary}08 100%)`,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "60px 16px",
          }}
        >
          <div style={{ maxWidth: 560, width: "100%", textAlign: "center" }}>

            {/* Animated icon circle */}
            <div
              style={{
                width: 110,
                height: 110,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #fff0f0, #ffe4e4)",
                border: "3px solid #f46a6a22",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 28px",
                boxShadow: "0 8px 32px rgba(244,106,106,0.18)",
              }}
            >
              <span style={{ fontSize: 52 }}>😕</span>
            </div>

            {/* Heading */}
            <h1
              style={{
                fontSize: "clamp(24px, 5vw, 36px)",
                fontWeight: 800,
                color: c.primary,
                marginBottom: 12,
                lineHeight: 1.2,
              }}
            >
              Payment Not Completed
            </h1>

            <p
              style={{
                fontSize: 16,
                color: c.darkGrey,
                lineHeight: 1.7,
                maxWidth: 420,
                margin: "0 auto 32px",
              }}
            >
              Looks like you went back before completing the checkout.{" "}
              <strong style={{ color: c.primary }}>No worries</strong> — nothing
              was charged. You can try again anytime.
            </p>

            {/* Info cards */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                gap: 14,
                marginBottom: 36,
              }}
            >
              {[
                { icon: "💳", title: "No Charge", desc: "Your card was not charged" },
                { icon: "🔒", title: "100% Safe", desc: "Stripe-secured checkout" },
                { icon: "↩️", title: "Try Again", desc: "Pick a plan whenever you're ready" },
              ].map((item) => (
                <div
                  key={item.title}
                  style={{
                    background: "#fff",
                    borderRadius: 14,
                    padding: "18px 14px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                    border: `1px solid ${c.lightGrey}`,
                  }}
                >
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: c.primary, marginBottom: 4 }}>
                    {item.title}
                  </div>
                  <div style={{ fontSize: 12, color: c.darkGrey, lineHeight: 1.5 }}>
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={() => navigate(Paths.subscriptionPlans)}
                style={{
                  padding: "13px 32px",
                  borderRadius: 12,
                  border: "none",
                  background: `linear-gradient(135deg, ${c.secondary}, #00a67e)`,
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 15,
                  cursor: "pointer",
                  boxShadow: `0 6px 20px ${c.secondary}44`,
                  transition: "opacity 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                🚀 View Plans Again
              </button>

            </div>

            {/* Help text */}
            <p style={{ marginTop: 28, fontSize: 13, color: c.darkGrey }}>
              Need help choosing a plan?{" "}
              <span
                style={{ color: c.secondary, fontWeight: 600, cursor: "pointer" }}
                onClick={() => navigate(Paths.subscriptionPlans)}
              >
                Browse all plans →
              </span>
            </p>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SubscriptionCancel;
